// extracted by mini-css-extract-plugin
export default {"formContainer":"home_formContainer__weU4G","input":"home_input__vCH8w","button":"home_button__bS0Tu"};